import React from 'react'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import LinearProgress from '@material-ui/core/LinearProgress'
import DeleteIcon from '@material-ui/icons/Delete'
import { localized } from 'decorators'
import { format } from 'utils/stringUtilities'
import { ConfirmButton } from 'components/buttons'
import { useStyles } from './index.css'

const NoFileAttachmentItem = (props) => {
  return (
    <ListItem>
      <ListItemText primary={props.localize('fileAttachments.noFiles')} className={props.classes.noItem} />
    </ListItem>
  )
}

const DownloadableItem = ({ fileAttachment, classes, localize, onDelete, onDownload, onDownloadProgress, onError }) => {
  const handleDownload = React.useCallback(() => {
    onDownloadProgress(0)
    onDownload(fileAttachment, onDownloadProgress, onError)
  }, [fileAttachment, onDownload, onDownloadProgress, onError])
  const handleDelete = React.useCallback(() => onDelete(fileAttachment), [fileAttachment, onDelete])
  const tooltip = `${localize('fileAttachments.downloadFile')} ${fileAttachment.fileName}`
  return (
    <div className={classes.item}>
      <div className={classes.delete}>
        <ConfirmButton
          onConfirm={handleDelete}
          confirmMessage={format(localize('fileAttachments.confirmDelete'), fileAttachment.fileName)}
          padding={0}
          minWidth='inherit'
          className='delete-button'
          title={localize('fileAttachments.deleteFileTooltip')}
          confirmTitle={localize('common.confirm')}
          color='inherit'
          width={30}
          variant='text'>
            <DeleteIcon style={{ marginRight: 0 }} />
          </ConfirmButton>
        </div>
        <div
          className={fileAttachment.isNew ? `${classes.file} ${classes.newFile}` : classes.file}
          onClick={handleDownload}
          title={tooltip}>{fileAttachment.fileName}</div>
    </div>
  )
}
export const FileAttachmentItem = localized((props) => {
  const classes = useStyles()
  const [downloadProgress, setDownloadProgress] = React.useState(0)
  const { fileAttachment, localize, onDelete, onDownload, onError } = props
  const showProgress = downloadProgress > 0 && downloadProgress < 100
  if (fileAttachment) {
    return (
      <ListItem>
        <ListItemText
          disableTypography
          primary={<React.Fragment>
            <DownloadableItem
              classes={classes}
              onDownload={onDownload}
              onDownloadProgress={setDownloadProgress}
              onError={onError}
              onDelete={onDelete}
              fileAttachment={fileAttachment}
              localize={localize} />
            </React.Fragment>}
          secondary={showProgress && <LinearProgress variant='determinate' value={downloadProgress} />}
        />
      </ListItem>
    )
  }
  return (<NoFileAttachmentItem {...props} classes={classes} />)
})

